import html2canvas from 'html2canvas-pro';
import { jsPDF } from 'jspdf';

/** A folha: A4 retrato, em milimetros, com margem confortavel de leitura. */
const PAGINA = { largura: 210, altura: 297, margem: 10 };

/**
 * O que entra no PDF: o mesmo conteudo que a impressao mostra. A marca fica
 * no `<main>` do layout, entao qualquer tela nova ja nasce exportavel.
 */
function conteudoDaTela(): HTMLElement {
  return (document.querySelector('[data-print-root]') as HTMLElement) ?? document.body;
}

/**
 * Gera o PDF da tela inteira e devolve a URL do arquivo em memoria - e ela
 * que o visualizador da modal abre. Quem chama e responsavel por revogar.
 *
 * A pagina e recortada em fatias de altura A4: sem isso o relatorio longo
 * sairia espremido em uma folha so.
 */
export async function renderScreenPdf(): Promise<string> {
  const alvo = conteudoDaTela();

  const canvas = await html2canvas(alvo, {
    // Dobro da resolucao: no zoom o texto continua legivel.
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    // Os botoes de acao nao fazem sentido no papel.
    ignoreElements: (elemento) => elemento.classList?.contains('print:hidden'),
  });

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const larguraUtil = PAGINA.largura - PAGINA.margem * 2;
  const alturaUtil = PAGINA.altura - PAGINA.margem * 2;

  // Quantos pixels do canvas cabem em uma folha, mantendo a proporcao.
  const pixelsPorPagina = Math.floor((canvas.width * alturaUtil) / larguraUtil);
  const paginas = Math.max(1, Math.ceil(canvas.height / pixelsPorPagina));

  for (let indice = 0; indice < paginas; indice += 1) {
    const inicio = indice * pixelsPorPagina;
    const altura = Math.min(pixelsPorPagina, canvas.height - inicio);

    const fatia = document.createElement('canvas');
    fatia.width = canvas.width;
    fatia.height = altura;
    fatia
      .getContext('2d')
      ?.drawImage(canvas, 0, inicio, canvas.width, altura, 0, 0, canvas.width, altura);

    if (indice > 0) pdf.addPage();

    pdf.addImage(
      fatia.toDataURL('image/jpeg', 0.92),
      'JPEG',
      PAGINA.margem,
      PAGINA.margem,
      larguraUtil,
      (altura * larguraUtil) / canvas.width,
    );
  }

  return URL.createObjectURL(pdf.output('blob'));
}
